import React, { useState, useRef, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

const ApiImage = ({ path, apiRoot = process.env.REACT_APP_API_HOST }) => {
  const [imageProcessed, setImageProcessed] = useState(false);
  const [goodImage, setGoodImage] = useState(false);
  let ImageEl = useRef(new Image());

  useEffect(() => {
    ImageEl.current.onload = () => {
      setGoodImage(true);
      setImageProcessed(true);
    };

    ImageEl.current.onerror = () => {
      setImageProcessed(true);
    };

    ImageEl.current.src = `${apiRoot}${path}`;
  }, []);

  if (!imageProcessed) return <CircularProgress size="small" />;

  return goodImage ? (
    <img src={ImageEl.current.src} alt="" style={{ maxWidth: "100%" }} />
  ) : null;
};

export { ApiImage };
